<template>
	<svg @click="onClick" class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
		<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
		<path d="M0 0h24v24H0z" fill="none" />
	</svg>
</template>

<script>
export default {
	methods: {
		onClick() {
			if (window.lutify.activeModal.find("button.--cancel").length) window.lutify.activeModal.find("button.--cancel").click();
			else window.UI.hideModal();
		},
	},
};
</script>

<style lang="scss" scoped>
i {
	// cursor: pointer;
}
</style>
